export type ParsedDsn = {
  origin: string;
  projectId: string;
  publicKey: string;
  envelopeUrl: string;
};

export function parseDsn(dsn: string | undefined): ParsedDsn | null {
  if (!dsn) return null;
  try {
    const url = new URL(dsn);
    const publicKey = url.username;
    const projectId = url.pathname.replace(/^\//, '');
    if (!publicKey || !projectId) return null;
    const origin = `${url.protocol}//${url.host}`;
    return {
      origin,
      projectId,
      publicKey,
      envelopeUrl: `${origin}/api/${projectId}/envelope/`,
    };
  } catch {
    return null;
  }
}
